var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileInput"},[_c('el-cascader',{attrs:{"props":_vm.props,"placeholder":"请选择省市区"},on:{"change":_vm.change},model:{value:(_vm.myAnswer),callback:function ($$v) {_vm.myAnswer=$$v},expression:"myAnswer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }